import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { setReports, setReport, updateReport, deleteReport } from '../actions/report'
import { ConciseReport, Report } from '../../shared/model/models'

type ReportState = {
  reports: ConciseReport[]
  currentReport: Report | null
}

const initialState: ReportState = {
  reports: [],
  currentReport: null,
}

const reportSlice = createSlice({
  name: 'currentReport',
  initialState,
  reducers: {
    setCurrentReport: (state, action: PayloadAction<Report>) => {
      state.currentReport = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setReports.fulfilled, (state, action: PayloadAction<ConciseReport[]>) => {
      state.reports = action.payload.sort(
        (a, b) => new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf(),
      )
    })
    builder.addCase(setReport.fulfilled, (state, action: PayloadAction<Report>) => {
      state.currentReport = action.payload
    })
    builder.addCase(updateReport.fulfilled, (state, action: PayloadAction<Report>) => {
      state.currentReport = action.payload
    })
    builder.addCase(deleteReport.fulfilled, (state, action: PayloadAction<number | null>) => {
      if (action.payload) {
        state.reports = state.reports.filter((r) => r.id !== action.payload)
        state.currentReport = null
      }
    })
  },
})

export const reportActions = reportSlice.actions
export default reportSlice.reducer
